import React from 'react';
import { Grid, Paper, Typography, Stack, Tooltip, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { formatCurrency } from '../../utils/formatters';

export const ORDER_PERFORMANCE_CARDS = [
  {
    key: 'total_gmv',
    label: 'Order Revenue (GMV)',
    color: '#1976d2',
    format: formatCurrency,
    tooltip: 'Total order revenue flowing through the Handoff network in this period.',
    subKey: 'total_orders',
    subLabel: 'orders',
  },
  {
    key: 'total_orders',
    label: 'Orders',
    color: '#2e7d32',
    format: (v) => (v || 0).toLocaleString(),
    tooltip: 'Total unique orders with approved commissions across all retailers.',
  },
  {
    key: 'total_commission',
    label: 'Total Commission',
    color: '#9c27b0',
    format: formatCurrency,
    tooltip: 'Total commission paid by buying retailers to acquiring retailers (match_retailer_commission_paid).',
  },
  {
    key: 'handoff_commission',
    label: 'Handoff Commission',
    color: '#ed6c02',
    format: formatCurrency,
    tooltip: "Handoff's share of commission from each order.",
  },
  {
    key: 'network_cpo',
    label: 'Network CPO',
    color: '#0288d1',
    format: formatCurrency,
    tooltip: 'Average total commission per order across the network.',
  },
];

const NetworkHeroKPIs = ({ data, cards = ORDER_PERFORMANCE_CARDS }) => {
  if (!data) return null;

  return (
    <Grid container spacing={{ xs: 1.5, sm: 2 }}>
      {cards.map(({ key, label, color, format, tooltip, subKey, subLabel }) => (
        <Grid key={key} size={{ xs: 6, sm: 6, md: true }}>
          <Paper
            sx={{
              p: { xs: 1.5, sm: 2 },
              borderTop: `3px solid ${color}`,
              height: '100%',
            }}
            elevation={1}
          >
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <Typography variant="body2" color="text.secondary" noWrap>
                {label}
              </Typography>
              {tooltip && (
                <Tooltip title={tooltip} arrow>
                  <IconButton size="small" sx={{ p: 0 }}>
                    <InfoOutlined sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
            <Typography variant="h5" fontWeight="bold" sx={{ mt: 0.5, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              {format(data[key])}
            </Typography>
            {subKey && (
              <Typography variant="body2" color="text.secondary">
                {(data[subKey] || 0).toLocaleString()} {subLabel}
              </Typography>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default NetworkHeroKPIs;
